"use strict";

const SaveIncompleteModal = function () {
  const cancelText = "Cancel";
  const saveAndCloseText = "Save & Close";
  const saveAndEditText = "Save & Edit Later";

  var showConfirmSaveIncompleteModal = function (
    entityName,
    entityKind,
    incompleteFieldNames,
    saveCallback,
    cancelCallback = () => {},
    showHelpCenterText = false,
  ) {
    MessageModal.showConfirmWarningModal(
      null,
      saveCallback,
      cancelText,
      saveAndCloseText,
      nunjucks.render("dynamicModals/confirmSaveIncomplete.njk", {
        ...getIncompleteFieldsProps(entityName, entityKind, incompleteFieldNames),
        showHelpCenterText,
        cancelText,
        saveAndCloseText,
      }),
      cancelCallback,
    );
  };

  var showWarnSaveIncompleteModal = function (
    entityName,
    entityKind,
    incompleteFieldNames,
    additionalText,
  ) {
    MessageModal.showSimpleWarningModal(
      getIncompleteFieldsBodyText(entityName, entityKind, incompleteFieldNames, additionalText),
      true,
    );
  };

  var showWarnSaveSubmitModal = function (
    incompleteFields = {
      entityName: null,
      entityKind: null,
      incompleteFieldNames: null,
    },
    buttonCallbacks = {
      cancelCallback: null,
      saveCallback: null,
      submitCallback: null,
    },
    customSuccessMessage = null,
  ) {
    const buttons = getWarnSaveSubmitButtons(incompleteFields, buttonCallbacks);
    const bodyText = nunjucks.render("dynamicModals/warnSaveSubmit.njk", {
      ...getIncompleteFieldsProps(
        incompleteFields.entityName,
        incompleteFields.entityKind,
        incompleteFields.incompleteFieldNames,
      ),
      hasIncompleteFields: incompleteFields.incompleteFieldNames.length !== 0,
      customSuccessMessage,
      submitButtonText: getSubmitButtonText(incompleteFields.entityKind),
      pdfWillBeEmailed: Session.notificationEnabled("pdf-letters"),
      cancelText,
      saveAndEditText,
    });

    MessageModal.showCustomWarningModal(bodyText, buttons);
  };

  var getIncompleteFieldsBodyText = function (
    entityName,
    entityKind,
    incompleteFieldNames,
    additionalText,
  ) {
    return nunjucks.render("dynamicModals/saveIncompleteFields.njk", {
      ...getIncompleteFieldsProps(entityName, entityKind, incompleteFieldNames),
      additionalText,
    });
  };

  var getIncompleteFieldsProps = function (entityName, entityKind, incompleteFieldNames) {
    return {
      entityName,
      entityKind,
      incompleteFieldNames,
      isScenario: Tree.get("tool") === "scenario",
      pluralSuffix: Misc.pluralIsAre(incompleteFieldNames.length > 1),
      showUnknownTypeNote: incompleteFieldNames.includes("sBMP/FCS type"),
    };
  };

  var getWarnSaveSubmitButtons = function (incompleteFields, buttonCallbacks) {
    const buttons = [
      {
        text: cancelText,
        type: "secondary",
        callback: buttonCallbacks.cancelCallback,
      },
      {
        text: saveAndEditText,
        type: "primary",
        callback: buttonCallbacks.saveCallback,
      },
      {
        text: getSubmitButtonText(incompleteFields.entityKind),
        type: "primary-submit",
        callback: function () {
          MessageModal.showFinalConfirmModal(
            incompleteFields.entityKind,
            incompleteFields.entityName,
            buttonCallbacks.submitCallback,
          );
        },
        stayOpenOnClick: true,
        disabled: incompleteFields.incompleteFieldNames.length > 0,
      },
    ];

    return buttons;
  };

  var getSubmitButtonText = function (entityKind) {
    const submitKind = NunjucksFilters.capFirstLetters(entityKind);
    return `Submit ${submitKind}`;
  };

  return {
    showConfirmSaveIncompleteModal,
    showWarnSaveIncompleteModal,
    showWarnSaveSubmitModal,
    getIncompleteFieldsBodyText,
  };
};

module.exports = SaveIncompleteModal();

const MessageModal = require("./messageModal");
const Misc = require("../misc");
const NunjucksFilters = require("../general/nunjucksFilters");
const Tree = require("../tree");
const Session = require("../login/session");
